import React, { useState, useMemo, useEffect } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import {
  PlusIcon,
  PencilIcon,
  TrashIcon,
} from "@heroicons/react/24/outline";
import not_found from "../../assets/images/sattva_misc/not_found.jpg";

const AcademyInsights = () => {
  const navigate = useNavigate();

  const token = localStorage.getItem("Editor_token");
  const isAuthenticated = !!token && token.trim().length > 10;

  const [academy, setAcademy] = useState([]);
  const [loading, setLoading] = useState(true);

  const [search, setSearch] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [editingBlog, setEditingBlog] = useState(null);
  const [selectedCate, setSelectedCate] = useState("Corporate sustainability");

  const categories = [
    "Corporate sustainability",
    "Policy, Standards & Regulations",
    "Foundations",
    "Climate & Carbon",
  ];

  useEffect(() => {
    const fetchAcademy = async () => {
      try {
        const res = await fetch("https://sattva-backend.demetrix.in/academy");
        const json = await res.json();

        if (json.status === "success") {
          const formattedAcademy = json.data.map((item) => {
            const imageUrl = item.media?.find((m) => m.type === "image")?.url;

            return {
              id: item.slug,
              slug: item.slug,
              category: item.category,
              title: item.title,
              description: item.description,
              content: item.content,
              media: item.media || [],
              imgSrc: formatImageUrl(imageUrl), // ✅ correct usage
              updated: new Date(
                item.updated_at || item.created_at,
              ).toDateString(),
              timeToRead: "5 min read",
            };
          });
          setAcademy(formattedAcademy);
        }
      } catch (err) {
        console.error("Failed to load academy data", err);
      } finally {
        setLoading(false);
      }
    };

    fetchAcademy();
  }, []);

  const categorizedAcademy = useMemo(() => {
    return academy.filter((aca) => aca.category === selectedCate);
  }, [academy, selectedCate]);

  const filteredAcademy = useMemo(() => {
    return categorizedAcademy?.filter((blog) =>
      blog.title.toLowerCase().includes(search.toLowerCase()),
    );
      // eslint-disable-next-line
  }, [academy, search, selectedCate]);

  const featuredBlog = filteredAcademy[0];
  const listAcademy = filteredAcademy.slice(1);

  // const filteredAcademy = useMemo(() => {
  //   return academy?.filter((item) => {
  //     const matchesCategory = selectedCate
  //       ? item.category === selectedCate
  //       : true;

  //     const matchesSearch = search
  //       ? item.title.toLowerCase().includes(search.toLowerCase())
  //       : true;

  //     return matchesCategory && matchesSearch;
  //   });
  // }, [academy, selectedCate, search]);

  // const featuredBlog = filteredAcademy[0];
  // const listAcademy = filteredAcademy.slice(1);

  const handleDelete = async (slug) => {
    if (!window.confirm("Delete this academy article?")) return;

    try {
      const res = await fetch(
        `https://sattva-backend.demetrix.in/acadmey/${slug}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = await res.json();

      if (data.status === "success") {
        setAcademy((prev) => prev.filter((b) => b.slug !== slug));
        alert("Deleted successfully");
      } else {
        alert(data.message || "Delete failed");
      }
    } catch (error) {
      console.error(error);
      alert("Server error while deleting");
    }
  };

  // const handleSave = async () => {
  //   if (!editingBlog?.title) {
  //     alert("Title is required");
  //     return;
  //   }

  //   try {
  //     const res = await fetch(
  //       `https://sattva-backend.demetrix.in/academy/${editingBlog.slug}`,
  //       {
  //         method: "PUT",
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`,
  //         },
  //         body: JSON.stringify({
  //           title: editingBlog.title,
  //           description: editingBlog.description,
  //           content: editingBlog.content,
  //           category: editingBlog.category,
  //         }),
  //       },
  //     );

  //     const data = await res.json();

  //     if (data.status === "success") {
  //       setAcademy((prev) =>
  //         prev.map((b) => (b.slug === editingBlog.slug ? editingBlog : b)),
  //       );
  //       setModalOpen(false);
  //       setEditingBlog(null);
  //       alert("Updated successfully");
  //     } else {
  //       alert(data.message || "Update failed");
  //     }
  //   } catch (error) {
  //     console.error(error);
  //     alert("Server error while updating");
  //   }
  // };

  const addMedia = () => {
    setEditingBlog((prev) => ({
      ...prev,
      media: [...(prev.media || []), { type: "image", url: "", caption: "" }],
    }));
  };

  const handleMediaChange = (index, field, value) => {
    const updatedMedia = [...editingBlog.media];
    updatedMedia[index][field] = value;
    setEditingBlog((prev) => ({ ...prev, media: updatedMedia }));
  };

  const removeMedia = (index) => {
    setEditingBlog((prev) => ({
      ...prev,
      media: prev.media.filter((_, i) => i !== index),
    }));
  };
  const handleAcademySubmit = async (e) => {
    e.preventDefault();

    if (!token) {
      alert("Unauthorized");
      return;
    }

    try {
      const isEdit = !!editingBlog.slug;

      const url = isEdit
        ? `https://sattva-backend.demetrix.in/academy/${editingBlog.slug}`
        : `https://sattva-backend.demetrix.in/academy`;

      const res = await fetch(url, {
        method: isEdit ? "PUT" : "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(editingBlog),
      });

      const data = await res.json();

      if (data.status === "success") {
        alert(isEdit ? "Updated successfully" : "Created successfully");
        setModalOpen(false);
        setEditingBlog(null);

        window.location.reload();
      } else {
        alert(data.message || "Operation failed");
      }
    } catch (err) {
      console.error(err);
      alert("Something went wrong");
    }
  };
  const formatImageUrl = (url) => {
    if (!url) return not_found;

    // Google Drive handling
    if (url.includes("drive.google.com")) {
      const match = url.match(/\/d\/([^/]+)/);
      if (match?.[1]) {
        return `https://drive.google.com/thumbnail?id=${match[1]}&sz=w1200`;
      }
    }

    return url;
  };

  return (
    <article
      className="min-h-[calc(100vh-100px)] flex flex-col items-center p-4 py-36
      bg-gradient-to-b from-green-600/20 dark:from-green-600/40 via-green-600/10 dark:via-green-600/20 to-transparent"
    >
      {loading ? (
        <div className="py-40 text-center text-lg">
          Loading Academy content...
        </div>
      ) : (
        <div className="container">
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1 }}
            className="flex flex-col items-center"
          >
            {/* <h6 className="text-blue-600 uppercase mb-2">
              Learning & Insights
            </h6> */}
            <h4 className="lg:text-5xl text-4xl lg:leading-normal leading-normal font-medium mb-4 position-relative dark:text-white text-center">Discover our Resources</h4>
            {/* <h3 className="lg:text-5xl text-4xl dark:text-white text-center">
              Discover our Resources
            </h3> */}
          </motion.div>

          <p className="text-center text-slate-500 dark:text-slate-300 max-w-xl mx-auto my-4">
            Explore Academy, News, Webinars and more from our ESG experts.
          </p>

          <section>
            <h2 className="text-3xl font-bold text-center mb-8 dark:text-white">
              Academy
            </h2>

            <div className="flex flex-wrap justify-center gap-3 mb-12">
              {categories?.map((cate) => (
                <button
                  key={cate}
                  onClick={() => setSelectedCate(cate)}
                  className={`px-5 py-2 rounded-full text-sm font-medium transition-all duration-300 border
          ${selectedCate === cate
                      ? "bg-blue-600 text-white shadow-md scale-105"
                      : "bg-slate-100 dark:bg-slate-800 hover:bg-blue-100 dark:hover:bg-slate-700"
                    }`}
                >
                  {cate}
                </button>
              ))}
            </div>
            <h6 className="text-3xl mb-6">{selectedCate}</h6>
            <div className="card card-body">
              <div className="flex gap-3 mb-6">
                {
                  categorizedAcademy?.length > 0 && <div className="flex-1 bg-green-100/30 p-2 rounded-xl shadow-md">
                    <input
                      placeholder="Search academy..."
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                      className="bg-transparent w-full outline-none"
                    />
                  </div>
                }
                {isAuthenticated && (
                  <button
                    onClick={() => {
                      setEditingBlog({
                        category: "",
                        title: "",
                        description: "",
                        content: "",
                        media: [],
                      });
                      setModalOpen(true);
                    }}
                    className="p-2 rounded-full bg-green-200 text-green-700 hover:bg-green-300 transition"
                  >
                    <PlusIcon className="w-5 h-5" />
                  </button>
                )}
              </div>
              <div className="grid max-md:grid-cols-1 md:flex flex-col md:flex-col-reverse lg:grid lg:grid-cols-[1fr_2fr] gap-6">
                {categorizedAcademy?.length === 0 ? (
                  <div className="col-span-full flex items-center justify-center min-h-[300px]">
                    <motion.div
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.5 }}
                      className="bg-white dark:bg-slate-900 border border-slate-200 
                   dark:border-slate-700 rounded-2xl shadow-sm 
                   p-8 max-w-md w-full text-center"
                    >
                      <motion.img
                        src={not_found}
                        alt="No academy content"
                        className="mx-auto h-40 mb-6"
                        animate={{ y: [0, -6, 0] }}
                        transition={{
                          duration: 2,
                          repeat: Infinity,
                          ease: "easeInOut",
                        }}
                      />

                      <h3 className="text-xl font-semibold text-slate-800 dark:text-slate-100 mb-2">
                        No "{selectedCate}" academy contents found
                      </h3>

                      <p className="text-slate-500 dark:text-slate-400">
                        We couldn’t find any academy content for "{selectedCate}" here. Once content is
                        published, it’ll show up right away.
                      </p>
                    </motion.div>
                  </div>
                ) : (
                  <>
                    <div className="flex flex-col gap-4">
                      <div className="grid md:grid-cols-2 lg:grid-cols-1 gap-4 max-h-[560px] overflow-y-auto pr-1">
                        {listAcademy?.map((blog) => (
                          <div
                            key={blog.id}
                            onClick={() => navigate(`/academy/${blog.slug}`)}
                            className="group relative border rounded-xl overflow-hidden shadow-sm cursor-pointer overflow-y-auto"
                          >
                            {isAuthenticated && (
                              <div className="absolute top-2 right-2 flex gap-1 opacity-0 group-hover:opacity-100">
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setEditingBlog(blog);
                                    setModalOpen(true);
                                  }}
                                  className="p-1 bg-blue-100 text-blue-700 rounded-full"
                                >
                                  <PencilIcon className="w-4 h-4" />
                                </button>
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleDelete(blog.slug);
                                  }}
                                  className="p-1 bg-red-100 text-red-700 rounded-full"
                                >
                                  <TrashIcon className="w-4 h-4" />
                                </button>
                              </div>
                            )}
                            <img
                              src={blog.imgSrc}
                              alt={blog.title}
                              className="h-40 w-full object-cover"
                              loading="lazy"
                              referrerPolicy="no-referrer"
                              onError={(e) => {
                                e.currentTarget.src = "/placeholder.jpg"; // optional fallback
                              }}
                            />

                            <div className="p-3">
                              <h4 className="font-semibold dark:text-white">
                                {blog.title}
                              </h4>
                              <span
                                className="inline-block text-xs mb-4 px-3 py-1 rounded-full 
                       border border-green-600 text-green-700"
                              >
                                {blog.category}
                              </span>

                              {blog.description && (
                                <p className="text-sm text-gray-600 dark:text-gray-300 mt-1 line-clamp-2">
                                  {blog.description}
                                </p>
                              )}

                              <div className="text-xs text-gray-500 flex justify-between mt-2">
                                <span>{blog.updated}</span>
                                <span>{blog.timeToRead}</span>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                    {featuredBlog && (
                      <div
                        onClick={() => navigate(`/academy/${featuredBlog.slug}`)}
                        className="border rounded-xl shadow-md overflow-hidden 
                     relative group cursor-pointer"
                      >
                        {isAuthenticated && (
                          <div
                            className="absolute top-3 right-3 flex gap-2 z-10
                            opacity-0 group-hover:opacity-100"
                          >
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                setEditingBlog(featuredBlog);
                                setModalOpen(true);
                              }}
                              className="p-2 bg-blue-100 text-blue-700 rounded-full"
                            >
                              <PencilIcon className="w-4 h-4" />
                            </button>

                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                handleDelete(featuredBlog.slug);
                              }}
                              className="p-2 bg-red-100 text-red-700 rounded-full"
                            >
                              <TrashIcon className="w-4 h-4" />
                            </button>
                          </div>
                        )}

                        <h4 className="p-4 font-medium dark:text-white">
                          {featuredBlog.title}
                        </h4>

                        <img
                          src={featuredBlog.imgSrc}
                          alt="blogs"
                          className="w-full h-64 object-cover"
                          loading="lazy"
                          referrerPolicy="no-referrer"
                          onError={(e) => {
                            e.currentTarget.src = "/placeholder.jpg"; // optional fallback
                          }}
                        />

                        <span
                          className="inline-block text-xs m-2 px-3 py-1 rounded-full 
                       border border-green-600 text-green-700"
                        >
                          {featuredBlog.category}
                        </span>

                        <div className="px-4 py-2 space-y-2">
                          {featuredBlog.description && (
                            <p className="text-sm text-gray-700 dark:text-gray-300 line-clamp-4">
                              {featuredBlog.description}
                            </p>
                          )}
                          {featuredBlog.content && (
                            <div className="text-sm line-clamp-5 pt-4">
                              {featuredBlog.content}
                            </div>
                          )}
                          <p className="text-xs text-gray-500">
                            {featuredBlog.updated} • {featuredBlog.timeToRead}
                          </p>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          </section>
        </div>
      )}

      {isAuthenticated && modalOpen && editingBlog && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 overflow-auto">
          <div
            className="bg-white rounded-xl p-6 w-full max-w-2xl 
                max-h-[85vh] overflow-y-auto relative mt-16"
          >
            <h3 className="text-xl font-semibold mb-4 text-slate-600">
              {editingBlog.slug ? "Edit Academy" : "Add Academy"}
            </h3>

            <form
              onSubmit={handleAcademySubmit}
              className="space-y-4 text-slate-600"
            >
              {/* <input
                placeholder="Category"
                value={editingBlog.category}
                onChange={(e) =>
                  setEditingBlog((p) => ({ ...p, category: e.target.value }))
                }
                className="w-full border rounded-lg p-2"
                required
              /> */}

              <input
                placeholder="Title"
                value={editingBlog.title}
                onChange={(e) =>
                  setEditingBlog((p) => ({ ...p, title: e.target.value }))
                }
                className="w-full border rounded-lg p-2 text-slate-600"
                required
              />

              <select
                className="w-full border rounded-lg p-2 text-slate-600"
                value={editingBlog?.category}
                onChange={(e) =>
                  setEditingBlog((p) => ({ ...p, category: e.target.value }))
                }
              >
                <option>Select category</option>
                {categories?.map((cate) => (
                  <option>{cate}</option>
                ))}
              </select>

              <textarea
                placeholder="Short description (optional)"
                value={editingBlog.description || ""}
                onChange={(e) =>
                  setEditingBlog((p) => ({ ...p, description: e.target.value }))
                }
                className="w-full border rounded-lg p-2"
                rows={3}
              />

              <textarea
                placeholder="Full content"
                value={editingBlog.content}
                onChange={(e) =>
                  setEditingBlog((p) => ({ ...p, content: e.target.value }))
                }
                className="w-full border rounded-lg p-2 whitespace-pre-line"
                rows={8}
                required
              />

              <div>
                <h4 className="font-semibold mb-2">Media</h4>

                {editingBlog.media?.map((m, idx) => (
                  <div
                    key={idx}
                    className="border rounded-lg p-3 mb-2 relative"
                  >
                    <select
                      value={m.type}
                      onChange={(e) =>
                        handleMediaChange(idx, "type", e.target.value)
                      }
                      className="border rounded p-1 w-full mb-1"
                    >
                      <option value="image">Image</option>
                      <option value="video">Video</option>
                    </select>

                    <input
                      placeholder={
                        m.type === "image" ? "Image URL" : "Video URL"
                      }
                      value={m.url}
                      onChange={(e) =>
                        handleMediaChange(idx, "url", e.target.value)
                      }
                      className="w-full border rounded p-1 mb-1"
                    />

                    <input
                      placeholder="Caption"
                      value={m.caption}
                      onChange={(e) =>
                        handleMediaChange(idx, "caption", e.target.value)
                      }
                      className="w-full border rounded p-1"
                    />

                    <button
                      type="button"
                      onClick={() => removeMedia(idx)}
                      className="absolute top-2 right-2 text-red-600"
                    >
                      ✕
                    </button>
                  </div>
                ))}

                {editingBlog.media?.length < 5 && (
                  <button
                    type="button"
                    onClick={addMedia}
                    className="bg-green-100 text-green-700 px-3 py-1 rounded"
                  >
                    + Add Media
                  </button>
                )}
              </div>

              <div className="flex justify-end gap-2">
                <button
                  type="submit"
                  className="bg-blue-600 text-white px-4 py-2 rounded-lg"
                >
                  Save
                </button>
                <button
                  type="button"
                  onClick={() => {
                    setModalOpen(false);
                    setEditingBlog(null);
                  }}
                  className="bg-gray-300 px-4 py-2 rounded-lg"
                >
                  Cancel
                </button>
              </div>
            </form>

            {/* <button
        onClick={() => {
          setModalOpen(false);
          setEditingBlog(null);
        }}
        className="absolute top-2 right-3 text-xl"
      >
        ✕
      </button> */}
          </div>
        </div>
      )}
    </article>
  );
};

export default AcademyInsights;
